import { Pipe, PipeTransform, inject } from '@angular/core';
import { WorkingDaysResponse } from '../../../../core/common/models/calendar.model';
import { CalendarHelperService } from '../services/calendar-helper.service';

@Pipe({
    name: 'calendarSegmentBg',
    standalone: true,
})
export class CalendarSegmentBgPipe implements PipeTransform {
    private readonly calendarHelperService = inject(CalendarHelperService);

    transform(date: Date, workingDays: WorkingDaysResponse): string {
        return this.calendarHelperService.getSegmentBgClass(date, workingDays);
    }
}
